import { CdkScrollableModule } from "@angular/cdk/scrolling";
import { ChangeDetectionStrategy, Component } from "@angular/core";

import { SLUGS } from "#shared/slugs";

import { PagesNavComponent } from "#modules/layouts/components/pages-nav/pages-nav.component";
import { SharedModule } from "#modules/shared";

import { BookInfoComponent } from "../book-info/book-info.component";
import { LibraryNavigationComponent } from "../library-navigation/library-navigation.component";

@Component({
  selector: "app-library-sidenav",
  templateUrl: "./library-sidenav.component.html",
  styleUrls: ["./library-sidenav.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, BookInfoComponent, LibraryNavigationComponent, PagesNavComponent, CdkScrollableModule],
})
export class LibrarySidenavComponent {
  readonly SLUGS = SLUGS;
}
